'use client';

import {
  getAppConfig,
  RakbankIslamicLogoIcon,
  RakbankIslamicLogoNoTextIcon,
} from '@bts-web/core-app-config';
import { DEFAULT_LOGO_SIZE } from '../../../constants';

interface AppLogoProps {
  size?: number;
  textLogoSize?: number;
  color?: string;
  isIslamicUser?: boolean;
  noText?: boolean;
  variant?: 'default' | 'inverted';
}

const { appLogoSize } = getAppConfig();

const AppLogo = ({
  size = appLogoSize || DEFAULT_LOGO_SIZE,
  textLogoSize,
  color,
  isIslamicUser = false,
  noText = false,
  variant,
}: AppLogoProps) => {
  const { appName, appLogo, appLogoInverted } = getAppConfig();

  const Logo =
    variant === 'inverted' && appLogoInverted ? appLogoInverted : appLogo;

  if (appName === 'Rakbank' && isIslamicUser) {
    return noText ? (
      <RakbankIslamicLogoNoTextIcon size={size} />
    ) : (
      <RakbankIslamicLogoIcon size={textLogoSize ?? size} />
    );
  }

  return <Logo size={size} color={color} />;
};

export { AppLogo };
